import { render, staticRenderFns } from "./RoleFormItem.vue?vue&type=template&id=2053edb0&scoped=true"
import script from "./RoleFormItem.vue?vue&type=script&lang=js"
export * from "./RoleFormItem.vue?vue&type=script&lang=js"
import style0 from "./RoleFormItem.vue?vue&type=style&index=0&id=2053edb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2053edb0",
  null
  
)

export default component.exports